import React from "react";
import { createUseStyles } from "react-jss";

const TRIANGLE_HEIGHT = 10;
const CLASSMATES = "Одноклассники";

const useStyles = createUseStyles((theme) => ({
	content: {
		color: theme.palette.colors.white,
		fontSize: "14px",
		fontFamily: theme.fonts.medium,
		lineHeight: 1,
	},
	tooltip: {
		position: "relative",
		"&:hover $contentWrapper": {
			display: "block",
		},
		"&:hover $contentMates": {
			display: "block",
		},
		"&:hover:after": {
			position: "absolute",
			transform: "translate(-50%, -100%)",
			display: "block",
			content: "''",
			width: 0,
			height: 0,
			borderLeft: `${TRIANGLE_HEIGHT}px solid transparent`,
			borderRight: `${TRIANGLE_HEIGHT}px solid transparent`,
			borderTop: `${TRIANGLE_HEIGHT}px solid ${theme.palette.colors.purplishBlue}`,
			top: 0,
			left: "50%",
		},
	},
	contentWrapper: {
		display: "none",
		position: "absolute",
		top: `-${TRIANGLE_HEIGHT - 1}px`,
		left: "-52px",
		transform: "translateY(-100%)",
		padding: "14px 24px",
		backgroundColor: theme.palette.colors.purplishBlue,
		borderRadius: "10px",
		minWidth: "80px",
	},
	contentMates: {
		display: "none",
		position: "absolute",
		top: `-${TRIANGLE_HEIGHT - 1}px`,
		left: "-99px",
		transform: "translateY(-100%)",
		padding: "14px 24px",
		backgroundColor: theme.palette.colors.purplishBlue,
		borderRadius: "10px",
		minWidth: "80px",
	},
	[`@media (min-width: ${theme.media.sm})`]: {
		tooltip: {
			position: "relative",
			"&:hover $contentWrapper": {
				display: "block",
			},
			"&:hover $contentMates": {
				display: "block",
			},
			"&:hover:after": {
				position: "absolute",
				transform: "translate(-50%, -100%)",
				display: "block",
				content: "''",
				width: 0,
				height: 0,
				borderLeft: `${TRIANGLE_HEIGHT}px solid transparent`,
				borderRight: `${TRIANGLE_HEIGHT}px solid transparent`,
				borderTop: `${TRIANGLE_HEIGHT}px solid ${theme.palette.colors.purplishBlue}`,
				top: 0,
				left: "50%",
			},
		},
		contentWrapper: {
			display: "none",
			position: "absolute",
			top: `-${TRIANGLE_HEIGHT}px`,
			left: "-50%",
			transform: "translateY(-100%)",
			padding: "14px 24px",
			backgroundColor: theme.palette.colors.purplishBlue,
			borderRadius: "10px",
			minWidth: "110px",
			whiteSpace: "nowrap",
		},
		contentMates: {
			display: "none",
			position: "absolute",
			top: `-${TRIANGLE_HEIGHT - 1}px`,
			left: "-50%",
			transform: "translateY(-100%)",
			padding: "14px 24px",
			backgroundColor: theme.palette.colors.purplishBlue,
			borderRadius: "10px",
			minWidth: "80px",
		},
	},
}));

export const PurpleTooltip = ({ children, content }) => {
	const classes = useStyles();

	return (
		<div className={classes.tooltip}>
			<div className={content === CLASSMATES ? classes.contentMates : classes.contentWrapper}>
				<div className={classes.content}>{content}</div>
			</div>
			{children}
		</div>
	);
};
